/* eslint-disable max-len */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { withRouter } from 'react-router-dom';
import Welcome from '../assets/dashboard/welcome.svg';
import Results from '../components/Results';
import {
  getResults, getResponses, startSurvey, getInProgressSurvey, getUserData, speak, openModal,
} from '../actions';
import SideBar from '../components/SideBar';
import MobileIncompatible from './MobileIncompatible';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {
      selectedToolkit: null,
    };
  }

  componentDidMount() {
    this.props.getUserData(this.props.userid); // to get finished surveys on upload
  }

  expandToolkit = (surveyid, toolkitid) => {
    if (this.state.selectedToolkit === toolkitid) {
      this.setState({ selectedToolkit: null });
    } else {
      this.props.getResults(this.props.userid, surveyid);
      this.props.getResponses(this.props.userid, surveyid);
      this.setState({ selectedToolkit: toolkitid });
    }
  }

  renderInProgressSurvey = () => {
    const survey = this.props.surveys[this.props.inProgressSurveys.slice(-1)[0]];
    const surveyid = survey.id;
    this.props.getInProgressSurvey(this.props.userid, surveyid);
    const percent = Math.round((this.props.numCompleted / survey.numQuestions) * 100);
    return (
      <div className="progress-body-container">
        <div className="progress-body-text-container">
          <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>{survey.name}</p>
          <button
            className="progress-button"
            type="button"
            onClick={() => this.props.history.push(`/survey/${surveyid}`)}
          >
            Continue
          </button>
        </div>
        <div className="progress-circle-container">
          <CircularProgressbarWithChildren
            value={percent}
            styles={{
              path: {
                stroke: '#48CAE4',
                // can use 'butt' or 'round'
                strokeLinecap: 'round',
                transition: 'stroke-dashoffset 0.5s ease 0s',
              },
              trail: {
                stroke: '#C3E8FE',
                strokeLinecap: 'butt',
              },
            }}
          >
            <div role="button" tabIndex={0} onClick={this.props.speak} className={`progress-circle-text color ${this.props.speechEnabled && 'bolded'}`}>
              <h3>
                {`${percent}%`}
              </h3>
              <p>Complete</p>
            </div>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    );
  }

  renderRecommended = () => {
    return Object.keys(this.props.surveys)
      .filter((surveyid) => {
        return !this.props.completedSurveys.includes(String(surveyid));
      })
      .slice(0, 2)
      .map((surveyid, index) => {
        const key = index + 1;
        const survey = this.props.surveys[surveyid];
        return (
          <div className="box recommended-box" key={key}>
            <img src={require(`../assets/dashboard/survey-icons/survey${surveyid}.svg`)} alt="survey-icon" />
            <div className="recommended-body">
              <h2 onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>{survey.name}</h2>
              <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>{survey.dashboardDescription}</p>
              { this.props.inProgressSurveys.includes(surveyid) ? (
                <button
                  style={{ marginRight: 20 }}
                  type="button"
                  onClick={() => this.props.history.push(`/survey/${surveyid}`)}
                >
                  Continue
                </button>
              ) : null}
              <button
                type="button"
                className={`${survey.name !== 'How I Approach My Work' && 'disabled-button'}`}
                onClick={() => {
                  if (survey.name !== 'How I Approach My Work') {
                    this.props.openModal('MissingSurvey');
                  } else { this.props.startSurvey(surveyid, this.props.userid, this.props.history); }
                }}
              >
                {this.props.inProgressSurveys.includes(surveyid) || this.props.completedSurveys.includes(surveyid) ? 'Restart' : 'Start'}
              </button>
            </div>
          </div>
        );
      });
  }

  renderCompleted = () => {
    return this.props.completedSurveys.map((surveyid, i) => {
      const key = i + 1;
      return (
        <div className="box result-box" id={`${this.props.surveys[surveyid].name} box`} key={key}>
          <div className="result-box-header">
            <h2 onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>
              {this.props.surveys[surveyid].name}
            </h2>
            <p onClick={() => this.expandToolkit(surveyid, i)}>
              {this.state.selectedToolkit === i ? 'Hide Toolkit ∧' : 'View Toolkit ∨'}
            </p>
          </div>
          {this.state.selectedToolkit === i
            ? (
              <div className="result-subcontainer-dashboard">
                <Results
                  survey={this.props.surveys[surveyid]}
                  openingStatement={this.props.surveys[surveyid].openingStatement}
                />
              </div>
            ) : null}
        </div>
      );
    });
  }

  render() {
    if (this.props.userid === null || Object.keys(this.props.surveys).length === 0) {
      return (<div>Loading...</div>);
    }
    return (
      <>
        <MobileIncompatible />
        <div className="dashboard-container">
          <SideBar defaultPage="home" />
          <div className="dashboard-body-container" id="dashboard-body-container">
            <div className="dashboard-body-subcontainer">
              <div className="dashboard-row-1">
                <div className="box welcome-box">
                  <div style={{ flexGrow: 1 }}>
                    <h2 onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>Hello, {this.props.username}!</h2>
                    <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>
                      This is your dashboard page. Here, you can browse toolkits, check on the status of incomplete surveys, and view your toolkit results after finishing a survey.
                    </p>
                  </div>
                  <img src={Welcome} alt="welcome" />
                </div>
                <div className="box progress-box">
                  <h2 onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>Your Ongoing Survey</h2>
                  {this.props.inProgressSurveys.length !== 0 ? (
                    this.renderInProgressSurvey()
                  ) : (
                    <div className="empty-progress-body-container">
                      <p onClick={this.props.speak} className={`color ${this.props.speechEnabled && 'bolded'}`}>Woohoo! No incomplete surveys to finish!</p>
                      <button
                        className="progress-button"
                        style={{ width: 150 }}
                        type="button"
                        onClick={() => this.props.history.push('/dashboard/allsurveys')}
                      >Browse Surveys
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <p onClick={this.props.speak} className={`dashboard-subheader color ${this.props.speechEnabled && 'bolded'}`}>Recommended Surveys</p>
              <div className="recommended-box-container">
                {this.renderRecommended()}
              </div>
              <p onClick={this.props.speak} className={`dashboard-subheader color ${this.props.speechEnabled && 'bolded'}`}>Your Past Surveys</p>
              <div className="past-surveys-container">
                { this.props.completedSurveys.length === 0
                  ? (
                    <div className="box no-past-surveys-container">
                      <p onClick={this.props.speak} className={`no-past-surveys color ${this.props.speechEnabled && 'bolded'}`}>
                        Once you’ve completed a survey, your results will show up here!
                      </p>
                    </div>
                  )
                  : this.renderCompleted() }
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => (
  {
    userid: state.user.userid,
    username: state.user.firstName,
    surveys: state.survey.surveys,
    completedSurveys: state.user.completedSurveys,
    inProgressSurveys: state.user.inProgressSurveys,
    numCompleted: state.survey.numCompleted,
    auth: state.user.authenticated,
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, {
  getResults, getUserData, getResponses, startSurvey, getInProgressSurvey, speak, openModal,
})(withRouter(Dashboard));
